export default "__VITE_ASSET__CA8FX8Cq__"